export default "__VITE_ASSET__BxWV1QZi__"